var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWalmart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-Ebay",
    transform: "translate(-24 -332)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(24 332)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "walmart_logo_icon_170230",
    d: "M-221.03,624.581c.365,0,.681-.2.706-.446l.365-4.192c0-.422-.487-.744-1.071-.744-.608,0-1.071.35-1.071.744l.365,4.192c.025.248.343.446.706.446m-2.239,1.317a.665.665,0,0,0-.025-.843l-3.383-2.406c-.343-.2-.876.05-1.168.57s-.243,1.116.1,1.315l3.748,1.786a.688.688,0,0,0,.73-.422m4.454,0c.195.325.511.5.73.4l3.748-1.786a.962.962,0,0,0,.1-1.315c-.294-.521-.828-.769-1.168-.57l-3.383,2.406a.706.706,0,0,0-.025.868m-2.214,3.919c.365,0,.681.2.706.447l.365,4.192c0,.422-.487.744-1.071.744-.608,0-1.071-.35-1.071-.744l.365-4.192c.025-.248.343-.447.706-.447m2.214-1.319c.195-.325.511-.5.73-.4l3.748,1.761a.962.962,0,0,1,.1,1.315c-.294.521-.828.769-1.168.57l-3.383-2.406a.666.666,0,0,1-.025-.843m-4.454,0a.665.665,0,0,1-.025.843l-3.383,2.406c-.343.2-.876-.049-1.168-.57s-.243-1.116.1-1.315L-224,628.1a.638.638,0,0,1,.73.4",
    transform: "translate(257.037 -283.2)",
    fill: "#6a6d84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalmart);
export default __webpack_public_path__ + "static/media/icon-walmart.a37853d6e39cc17dc94f43bd8e746ea9.svg";
export { ForwardRef as ReactComponent };